/* Dashboard */

/* Core */
import { useEffect, useState } from "react"
import { Helmet } from 'react-helmet-async'
import { Navigate, useParams, useMatch, Link } from "react-router-dom"

/* Data */
import chroma from "@chromaplatform/chromajs"

import ReactGA from 'react-ga4'

/* Components */
import { Avatar, Image } from 'antd'


import Hero from "../components/media/Hero"
import Layout from "../components/layout/Layout"
import TabComponent from "../components/layout/Tabs"
import ProfileOverview from "../components/profile/ProfileOverview"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt, faUser, faFlask, faUserAstronaut, faClock, faCalendar, faEye, faCog } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faInstagram, faYoutube, faTwitch } from '@fortawesome/free-brands-svg-icons'

/* Media */
import styles from './Profile.module.css'
import eyePurple from '../media/images/eye-purple.png'
import Screenshots from "components/media/screenshots/Screenshots"
import profileImage from '../media/images/screenshots/Screenshot_B3.jpg'
import { useStores } from "context/RootStoreContext"
import analyticEvent from "CHROMA-React/code/_analytics"

const color = require('chroma-js')
const _ = require('lodash')
const moment = require('moment')

const getUppercase = (string) => {
    return string.toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ')
}

const getTempBio = (seed) => {
    const entropy = ["amethyst", "river", "magic", "dragon", "tarot", "crystal", "Love", "yoga", "Eckhart Tolle", "happy", "fart", "Cattywampus", "Bumbershoot", "Hullaballoo", "Sporeganic", "chroma", "shanti", "puppy", "kitten", "nano", "micro", "fuzzy", "meow", "rarr", "1337", "newb", "sloth", "unicorn", "giraffe", "ice cream", "tiddlywinks", "gnarly", "tubular", "compassion", "Issac Newton", "particle physics", "quantum mechanics", "duality", "jadybear", "cadence", "gene", "booger", "airship", "dream", "flow state", "meditation", "mushroom", "tree", "Lubba", "Dub", "Bass", "Spirit", "Earth", "Water", "Air", "Fire", "Poly", "Cloud", "Animal", "Face", "Drop", "Crystal", "Star", "Ritual", "Virtual", "Android", "Phong", "Sporganic", "Crypto", "Mate", "Voxel", "Speaker", "Sun", "Moon", "Galaxy", "Glow", "Entropy", "FaceBlend", "Blender", "Tweet", "Share", "Cactus", "Vector", "Delta", "Mala", "Lion", "MachineElf", "Chakra", "Toadstool", "Mushroom", "Alien", "Dreams", "Ancient", "Future", "Circle", "Flower", "Merkaba", "Torus", "Tetra", "Terra", "Hydra", "Seed", "Flow", "Vibe", "Pheonix", "Awake", "Tree", "Breath", "Feather", "Elephant", "Fresh", "Cool", "Volume", "Pixel", "Tool", "Oracle", "EvrGlo", "Radial", "Cubic", "Fusion", "Diffraction", "Refraction", "Mycelial", "Fractal", "Particle", "Synthesis", "Reuptake", "Nootropic", "Cocky", "Nature", "Rooster", "Dinosaur", "BunnyRabbit", "Parrot", "Centipede", "Arachnid", "Voice", "Gradient", "Techtonic", "Ruby", "Emerald", "Silver", "Dove", "Conure", "Ringneck", "Blueprint", "Blueberry", "Strawberry", "Rasberry", "Puppet", "Earth", "Quest", "Branch", "Cuboid", "Spheroid", "Serpent", "Dragon", "Ginko", "Flamingo", "Wolfram", "Blinn", "Shader", "Knuckles", "Coconut", "Smartglasses", "Octagon", "Shen", "Ishtar", "5MAO", "Kachina", "Dancer", "Goat", "Snow", "Snake", "Tadpole", "Owl", "Lizard", "Fish", "Clown", "Thunder", "Party", "Trap", "Unicorn", "Aloha", "Lotus", "Pattern", "Candela", "Gummy", "Illuminati", "Venosa", "Rubiks", "CornChip", "GPU", "Random", "Merkaba", "Tetrahedron", "Cube", "Octahedron", "Dodecahedron", "Icosahedron", "Sweeney", "Carmack", "Gummy", "MIDI", "OSC", "Roy", "Hydrogen", "Iron", "Nickel", "Copper", "Zinc", "Mercury", "Iridium", "Tungsten", "Radon", "Xenon", "Neon", "Helium", "Calcium", "Radium", "Platinum", "Horse", "Plugin", "Controller", "Genre", "Kundalini", "Chakra", "Nadi", "Nandi", "Palette", "Iris", "Sushi", "Burrito", "Gibson", "Lennon", "Beatle", "Lucy", "Ringo", "Galactik", "Dali", "Klarwein", "Laffoley", "Grey", "Nature", "Protozoa", "Eukaryote", "Ribosome", "Apparatus", "Chloroplast", "Microbial", "Stromatolite", "Carbon", "Amino", "Organelle", "Electric", "Darwin", "Phosphoric", "Progenote", "Polymer", "Protocell", "Veins", "Mountain", "River", "Ocean", "Cat", "Orca", "Nova", "Escher", "Phoenix", "Shipibo", "Cubic", "Circular", "Anchor", "Submarine"]

    let index1 = Math.floor(Math.random() * (entropy.length-1)) + 1
    let index2 = Math.floor(Math.random() * (entropy.length-1)) + 1
    let index3 = Math.floor(Math.random() * (entropy.length-1)) + 1
    return `${getUppercase(entropy[index1])} ${getUppercase(entropy[index2])} ${getUppercase(entropy[index3])}`
}

function Profile(props) {
    const rootStore = useStores()

    const [minutesPlayed, setMinutesPlayed] = useState(0)
    const [lastOnline, setLastOnline] = useState()
    const [now, setNow] = useState(moment().subtract(5, 'minutes'))

    let { username } = useParams();

    const [profile, setProfile] = useState({
        avatar_url: "",
        id: "",
        bio: "",
        minutesPlayed: "",
        youtubeURL: "",
        instagramURL: "",
        facebookURL: "",
        twitchURL: "",
        primaryColor: "",
        secondaryColor: "",
        joined: ""
    })

    // GET Minutes Played
    useEffect(() => {
        const getMinutesPlayedData = async () => {
            const timeout = moment().subtract(5, 'minutes').unix()

            const minutesQuery = {
                service: "user-app-data",
                // query: {userId: profile.id, key: "Online"},
                query: {userId: profile.id, key: "Online"},
                fields: "value updatedAt"
            }
        
            chroma.find(minutesQuery, true).then(data => {
                // console.log('LAST SEEN:', _.get(data[0], "updatedAt"))
                setMinutesPlayed(_.get(data[0], "value.minutes", 0))
                setLastOnline(_.get(data[0], "updatedAt"))
            })
        }

        getMinutesPlayedData()

        // Triggers on teardown - Remove Events
        return () => {
            // global.removeEventListener('/user/authenticated', handleAuth)
        }
    }, [setMinutesPlayed, setLastOnline, profile])

    // GET PROFILE
    useEffect(() => {
        const getProfileData = async () => {
            const profileQuery = {
                service: "users",
                query: {username: username},
                fields: "_id createdAt username roles meta{profile style appData{MDVR{sessions{minutesPlayed}}}}"
            }
        
            chroma.find(profileQuery, true).then(data => {
                const userId = _.get(data[0], '_id')
                const usernamelocal = _.get(data[0], 'username')
                const profile = _.get(data[0], 'meta.profile')
                const style = _.get(data[0], 'meta.style')
                const minutesPlayed = _.get(data[0], 'meta.appData.MDVR.sessions.minutesPlayed')
                const location = `${_.get(data[0], 'meta.geolocation.current.city')}, ${_.get(data[0], 'meta.geolocation.current.region')}`
                const joined = moment(_.get(data[0], "createdAt", 1) * 1000).format("MM/DD/YYYY")

                /* Roles */
                const roleAssignments = _.get(data[0], 'roles.roleAssignments', [])
                let roles = []
                for (let i = 0; i < roleAssignments.length; i++) {
                    const roleName = _.get(roleAssignments[i], "roleName")
                    roles.push(roleName)
                }
                const isDeveloper = roles.includes('appDeveloper')
                const isMicronaut = roles.includes('micronaut')

                if(data && data.length > 0){
                    setProfile({
                        ...profile,
                        id: userId,
                        style: {...style},
                        username: usernamelocal,
                        minutesPlayed: minutesPlayed,
                        location: (_.get(data[0], 'meta.geolocation.current.city')) ? location : null,
                        joined: joined,
                        developer: isDeveloper,
                        micronaut: isMicronaut
                    })

                    analyticEvent(`Profile_View: ${usernamelocal}`, {})

                    // ReactGA.event({
                    //     category: 'Profile',
                    //     action: `View: ${usernamelocal}`
                    // })
                } else {
                    setProfile({notFound: true})

                    analyticEvent(`Profile_Not_Found: ${username}`, {})
                    // ReactGA.event({
                    //     category: 'Profile',
                    //     action: `Not Found: ${username}`
                    // })
                }
            })
        }

        getProfileData()

        // Triggers on teardown - Remove Events
        return () => {
            // global.removeEventListener('/user/authenticated', handleAuth)
        }
    }, [setProfile, username])

    if(profile.notFound){
        return(<Navigate to="/404"/>)
    }

    return (
        <div>
            <Layout noContainer={true}>
                <Helmet>
                    <title>{`CHROMA | ${username || Profile}`}</title>
                </Helmet>

                {/* Header Image */}
                <Hero 
                    height = {222}
                    primaryImageSource = {profileImage}
                    backgroundPosition = "center center"
                    color1 = {color.valid(_.get(profile, "style.colors.core.primaryColor", "rgb(66, 9, 126)")) && color(_.get(profile, "style.colors.core.primaryColor", "rgb(66, 9, 126)")).alpha(0.8).hex()}
                    color2 = {color.valid(_.get(profile, "style.colors.core.secondaryColor", "rgb(66, 9, 126)")) && color(_.get(profile, "style.colors.core.secondaryColor", "rgb(66, 9, 126)")).alpha(0.8).hex()}
                    />
                
                <div className="container">
                    <div className={styles.Profile}>
                        <div className="row">
                            <div className={`${styles.ProfileContainer} profileContainer col-lg-4 col-md-12 col-sm-12`}>
                                {/* Avatar */}
                                <div style={{textAlign: "center"}}>
                                    <div className={styles.Avatar}>
                                        <div className={styles.avatarContainer}>
                                            <img src={_.get(profile, "avatarURL") || eyePurple} className={styles.avatar} />
                                        </div>


                                        {moment(lastOnline * 1000).isAfter(now) &&
                                            <span className={styles.IconOnline}></span>
                                        }

                                        {/* {!moment(lastOnline * 1000).isAfter(now) &&
                                            <span className={styles.IconOffline}></span>
                                        } */}
                                    </div>
                                </div>

                                {/* Social Icons */}
                                <div className={styles.Icons}>
                                    {profile.facebookURL ? <a href={profile.facebookURL}><FontAwesomeIcon icon={faFacebook} /></a> : ""}                                    

                                    {profile.youtubeURL ? <a href={profile.youtubeURL}><FontAwesomeIcon icon={faYoutube} /></a> : ""}

                                    {profile.instagramURL ? <a href={profile.instagramURL}><FontAwesomeIcon icon={faInstagram} /></a> : ""}

                                    {profile.twitchURL ? <a href={profile.twitchURL}><FontAwesomeIcon icon={faTwitch} /></a> : ""}
                                </div>

                                {/* Username */}
                                <h3 className={styles.Username}>{profile.username || ""}</h3>
                                
                                {/* Location */}
                                {profile.location ? <div className={styles.Location}><FontAwesomeIcon icon={faMapMarkerAlt} /><span>{profile.location}</span></div> : ""}

                                {/* Developer Badge - TODO:: Move to <RoleComponent /> */}
                                {(profile.developer) ? 
                                    <div style={{textAlign:"center", marginBottom: "18px"}}><span style={{backgroundColor: "#6f0cd8", fontSize:"12px", color: "#fff", borderRadius:"4px",padding:"4px 8px"}}><FontAwesomeIcon icon={faFlask} style={{marginRight: "4px", position: "relative", top: "1px"}} />developer</span> </div>
                                    : null}

                                {/* Micronaut Badge - TODO:: Move to <RoleComponent /> */}
                                {(profile.micronaut) ? 
                                    <div style={{textAlign:"center", marginBottom: "18px"}}><span style={{backgroundColor: "#6f0cd8", fontSize:"12px", color: "#fff", borderRadius:"4px",padding:"4px 8px"}}><FontAwesomeIcon icon={faUserAstronaut} style={{marginRight: "4px", position: "relative", top: "0px"}} />micronaut</span> </div>
                                    : null}

                                {/* Bio */}
                                <div className={styles.Bio}>
                                    <div className={`${styles.CardBody} card-body`}>
                                        <p>{profile.bio || getTempBio(profile.username || "")}</p>
                                    </div>
                                </div>
                                
                                <ul className={styles.Data}>
                                    <li>
                                        <FontAwesomeIcon icon={faClock} className={styles.joinedIcon} /> Time Played <strong>{(Math.ceil((_.get(profile, "minutesPlayed", 0) + minutesPlayed) / 60)) || 0} hours</strong>
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCalendar} className={styles.joinedIcon} /> Member Since <strong>{profile.joined}</strong>
                                    </li>
                                    
                                    {lastOnline &&
                                        <li>
                                            <FontAwesomeIcon icon={faEye} className={styles.joinedIcon} />  Last Seen <strong>{moment(lastOnline * 1000).fromNow()}</strong>
                                        </li>
                                    }
                                </ul>

                                {_.get(rootStore, "AuthStore.user.username") === username &&
                                    <Link to="/settings" style={{display:"block"}}>
                                        <button className={`${styles.editButton}`}>
                                            <FontAwesomeIcon icon={faCog} className={styles.icon} />
                                            Edit Profile
                                        </button>
                                    </Link> 
                                }
                            </div>

                            <div className="col-lg-8">
                                {/*<TabComponent 
                                    amount="2"
                                    tab1text="Feed"
                                    tab1={<ProfileOverview profile={profile} />}
                                    tab2text="Screenshots"
                                    tab2={<Screenshots userId={profile.id} />}
                                />*/}

                                {/* <VideoEmbed /> */}
                                
                                <ProfileOverview profile={profile} />
                            </div>
                        </div>
                    
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default Profile